import randomId from 'random-id';
import { getCollectionFieldTraitOptions, getFieldOptionsForSelect } from '../pluginComponentApi';
import { ReferenceCreatedByFields } from 'drapcode-constant';
import { filterFieldsForDataTable } from '../../fields/FieldTypes';
export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pageCollection, projectId, collections, pfx, labelTable, toolbarBtnCode, ref, commands } =
    opts;
  const tableId = 'dc-data-table-dynamic-' + randomId(8, '');

  domc.addType(pfx, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: labelTable,
          'custom-name': labelTable,
          editable: true,
          projectId: projectId,
          traits: [
            {
              type: 'dt-dynamic-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'Records Per Page',
              name: 'data-cs-numberPerPage',
              placeholder: '10 (Default)',
            },
            ...domc.getType('table').model.prototype.defaults.traits,
          ],
          script: function () {
            if (typeof loadDynamicDataTable !== 'undefined') {
              console.log('*** Loading Dynamic DataTable from Collection...');
              loadDynamicDataTable(this);
            }
          },
        },

        init() {
          // Add the custom code toolbar button if requested and it's not already in
          // const toolbar = this.get('toolbar');
          // const id = pfx;
          // if (!toolbar.filter(tlb => tlb.id === id).length) {
          //   toolbar.unshift({
          //     id,
          //     command: commands.ddt_custom_code,
          //     attributes: { class: 'fa fa-gears', title: 'Configure Dynamic DataTable' },
          //     ...toolbarBtnCode,
          //   });
          // }
          const dynamicTable = this.closestType('data-table-dynamic');
          console.log('%c==> Dynamic DataTable dynamicTable :>> ', 'color:cyan', dynamicTable);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === pfx) {
            return {
              type: pfx,
            };
          }
        },
      },
    ),

    view: defaultView,
  });
}
